import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { CommonService } from '@common/services/common.service';

@Component({
    selector: 'app-receipt-confirmation-segment',
    templateUrl: './receipt-confirmation-segment.component.html',
    styleUrls: ['./receipt-confirmation-segment.component.scss'],
    providers: [CommonService]
})
export class ReceiptConfirmationSegment implements OnInit {
    @Input() model: any;

    ngOnInit(): void {
        
    }    

    get fspdReceivedDate(): Date | null {
        return this.model.operationalPlans?.length > 0
            ? this.model.operationalPlans[0]?.fspdReceivedDate
            : null;
    }

    set fspdReceivedDate(value: Date | null) {
        if (this.model.operationalPlans?.length > 0) {
            this.model.operationalPlans[0].fspdReceivedDate = value;
        } 
    }

    get fspdReceivedByFullName(): string {
        return this.model.operationalPlans?.length > 0
            ? this.model.operationalPlans[0]?.fspdReceivedBy?.fullName
            : null;
    }

    get captainReceivedDate(): Date | null {
        return this.model.operationalPlans?.length > 0
            ? this.model.operationalPlans[0]?.captainReceivedDate
            : null;
    }

    set captainReceivedDate(value: Date | null) {
        if (this.model.operationalPlans?.length > 0) {
            this.model.operationalPlans[0].captainReceivedDate = value;
        } 
    }

    get captainReceivedByFullName(): string {
        return this.model.operationalPlans?.length > 0
            ? this.model.operationalPlans[0]?.captainReceivedBy?.fullName
            : null;
    }

    set captainRemark(value: string | null) {
        if (this.model.operationalPlans?.length > 0) {
            this.model.operationalPlans[0].fspdRemark = value;
        } 
    }

    get captainRemark(): string {
        return this.model.operationalPlans?.length > 0
            ? this.model.operationalPlans[0]?.captainRemark
            : null;
    }

    set fspdRemark(value: string | null) {
        if (this.model.operationalPlans?.length > 0) {
            this.model.operationalPlans[0].fspdRemark = value;
        } 
    }

    get fspdRemark(): string {
        return this.model.operationalPlans?.length > 0
            ? this.model.operationalPlans[0]?.fspdRemark
            : null;
    }
}
